import * as fragments from './fragments';

export const cartGet = `
query cart($id: ID!) {
  cart(id: $id) {
    ${fragments.cart}
  }
}
`;

export const cartCreate = `
mutation cartCreate($input: CartInput!) {
  cartCreate(input: $input) {
    cart {
      id
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesAdd = `
mutation cartLinesAdd($cartId: ID!, $lines: [CartLineInput!]!) {
  cartLinesAdd(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesRemove = `
mutation cartLinesRemove($cartId: ID!, $lineIds: [ID!]!) {
  cartLinesRemove(cartId: $cartId, lineIds: $lineIds) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const cartLinesUpdate = `
mutation cartLinesUpdate($cartId: ID!, $lines: [CartLineUpdateInput!]!) {
  cartLinesUpdate(cartId: $cartId, lines: $lines) {
    cart {
      ${fragments.cart}
    }
    userErrors {
      field
      message
    }
  }
}`;

export const productsByTag = (tag) => `
  query {
    products(query: "tag:'${tag}'", first: 166) {
      nodes {
        ...on Product {
          ${fragments.product}
        }
      }
    }
  }
`;

export const productsByTags = (...tags) => {
  const query = tags.map((t) => `tag:'${t.replace(/(['"])/g, '\\$1')}'`).join(' OR ');

  return `
    query {
      products(query: "${query}", first: 200) {
        nodes {
          ...on Product {
            ${fragments.product}
          }
        }
      }
    }
  `;
};

export const productByHandle = () => `
  query product($handle: String!) {
    productByHandle(handle: $handle) {
      ${fragments.product}
    }
  }
`;

export const productById = (id) => `
  query {
    product(id: "gid://shopify/Product/${id}") {
      ${fragments.product}
    }
  }
`;
